import { RequestChannel } from "@vyne-shared/api/VynePayments/responses";
import { validateEmail } from "@vyne-shared/utils/email";
import { validatePhoneBoolean } from "./bulkRequestUtils.phone";
import type { BulkRequestRecord } from "api/clients/useBulkRequestQuery";

const vrTrueCache = new WeakSet<BulkRequestRecord>();
const vrFalseCache = new WeakSet<BulkRequestRecord>();

/**
 * Validate a Bulk Request record.
 * @param record The record to examine.
 * @returns True if the record is valid for submission, false otherwise.
 */
export function validateRecord(record: BulkRequestRecord) {
    if (vrTrueCache.has(record)) {
        return true;
    } else if (vrFalseCache.has(record)) {
        return false;
    }

    const result = validateRecordCore(record);

    getCache(result).add(record);
    return result;
}

function validateRecordCore(record: BulkRequestRecord) {
    return (
        (record.requestChannel === RequestChannel.SMS && validatePhoneBoolean(record)) ||
        (record.requestChannel === RequestChannel.Email && validateEmail(record.email)) ||
        (record.requestChannel === RequestChannel.Both && validatePhoneBoolean(record) && validateEmail(record.email))
    );
}

function getCache(result: boolean) {
    return result ? vrTrueCache : vrFalseCache;
}

/**
 * Generate row selection that selects all rows.
 * @param dataSource The collection of all rows to check.
 * @returns Row selection data.
 */
export function selectAll(dataSource: readonly Pick<BulkRequestRecord, "pmsId">[]) {
    return new Set<string>(dataSource.map((row) => row.pmsId));
}
